import { useState } from "react";
import { initials } from "../../utils/helpers/userDisplay";

// Portrait-or-initials avatar used app-wide. Resolves the photo from either the
// top-level `portrait_url` (AccountMini / user-list payloads) or the nested
// `teacher_profile.portrait_url` (the /auth/me/ self shape), so the same
// component works for the current user and for any listed teacher. Falls back to
// initials when there's no photo or the image fails to load (demo portraits are
// external, so an offline run still shows initials, never a broken image).
//
// `className` carries the container's size / shape / fallback colors / font —
// pass exactly what the call site used to put on its initials wrapper. The image
// fills the container with object-cover, so those colors only show as the
// fallback behind initials.
export default function Avatar({ user, className = "", imgClassName = "", alt = "", style }) {
  const [failedUrl, setFailedUrl] = useState(null);
  const url = user?.portrait_url || user?.teacher_profile?.portrait_url || "";
  const showImage = url && failedUrl !== url;
  return (
    <div className={`flex items-center justify-center overflow-hidden ${className}`} style={style}>
      {showImage ? (
        <img
          src={url}
          alt={alt}
          referrerPolicy="no-referrer"
          onError={() => setFailedUrl(url)}
          className={`w-full h-full object-cover ${imgClassName}`}
        />
      ) : (
        initials(user)
      )}
    </div>
  );
}
